import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getMergePreview, executeMerge } from './api';
import { MergeExecuteBody } from './types';

export const useMergePreview = ({
    tempMemberId,
    originalMemberId,
    enabled = false,
}: {
    tempMemberId: string;
    originalMemberId: string;
    enabled?: boolean;
}) =>
    useQuery({
        queryKey: ['memberMerge', 'preview', tempMemberId, originalMemberId],
        queryFn: () => getMergePreview(tempMemberId, originalMemberId),
        enabled: enabled && !!tempMemberId && !!originalMemberId,
        select: (data) => data?.data,
    });

export const useExecuteMerge = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body: MergeExecuteBody) => executeMerge(body),
        onSuccess: () => {
            // 회원 병합 후 회원목록/통계가 병합 전(중복 회원) 상태로 남지 않도록 무효화
            queryClient.invalidateQueries({ queryKey: ['getCenterMemberList'] });
            queryClient.invalidateQueries({ queryKey: ['getCenterMemberListQuery'] });
            queryClient.invalidateQueries({ queryKey: ['getCenterMemberListAPIQuery'] });
            queryClient.invalidateQueries({ queryKey: ['getMemberListForCenterAPI'] });
            queryClient.invalidateQueries({ queryKey: ['publicMember'] });
            queryClient.invalidateQueries({ queryKey: ['memberStats'] });
        },
    });
};
